/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fc_Tut_Next_TitleInputs */

const en_fc_tut_next_title = /** @type {(inputs: Fc_Tut_Next_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Coming from Premiere Pro?`)
};

/**
* | output |
* | --- |
* | "Coming from Premiere Pro?" |
*
* @param {Fc_Tut_Next_TitleInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const fc_tut_next_title = /** @type {((inputs?: Fc_Tut_Next_TitleInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fc_Tut_Next_TitleInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_fc_tut_next_title(inputs)
});
export { fc_tut_next_title as "fc.tut.next.title" }